module.exports = __webpack_public_path__ + "media/audios/kid/lesson_5/audio22-50a37b097506ce716ca0cb9ced59e2a3.m4a";